import { useMutation, useQueryClient } from 'react-query';
import {
  cancelAutoTopUp,
  type CancelAutoTopUpResponse,
  type CancelAutoTopUpBody
} from '../../services/bettieAutoTopUpService';

export function useCancelAutoTopUp() {
  const queryClient = useQueryClient();
  return useMutation<CancelAutoTopUpResponse, Error, { bettieAutoTopUpId: string; body: CancelAutoTopUpBody }>(
    ({ bettieAutoTopUpId, body }) => cancelAutoTopUp(bettieAutoTopUpId, body),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['bettieAutoTopUp']);
      }
    }
  );
}
